export default {
  methods: {
    zipCompare(option) {
      return `${option.zip}_${option.cityName}`;
    },
    zipLabel(option) {
      return `${option.zip} - ${option.cityName}`;
    },
    zipValue(option) {
      return option.zip;
    },
    zipSearch({
      cityName,
      state,
    }) {
      return (zip) => this.$store.dispatch('rapidKey/zipcodeSearch', {
        zip,
        cityName,
        state,
        visitId: this.$coa.visitId,
        token: this.$coa.token,
        origin: this.$store.get('config@rapidKeyUrl'),
      });
    },
    cityLabel(option) {
      return `${option.cityName}, ${option.state}`;
    },
    cityValue(option) {
      return option.cityName;
    },
    citySearch({
      zip,
      state,
    }) {
      return (cityName) => this.$store.dispatch('rapidKey/zipcodeSearch', {
        zip,
        cityName,
        state,
        visitId: this.$coa.visitId,
        token: this.$coa.token,
        origin: this.$store.get('config@rapidKeyUrl'),
      });
    },
    streetCompare(option) {
      return option.label;
    },
    streetLabel(option) {
      return option.label;
    },
    streetValue(option) {
      return option.streetAddress;
    },
    streetSearch({
      cityName,
      state,
      zipcode,
    }) {
      return (streetAddress) => this.$store.dispatch('rapidKey/addressSearch', {
        cityName,
        state,
        zipcode,
        streetAddress,
        token: this.$coa.token,
        visitId: this.$coa.visitId,
        origin: this.$store.get('config@rapidKeyUrl'),
      });
    },
  },
};
